import { DatePipe } from '@angular/common';
import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { Observable, forkJoin } from 'rxjs';
import { DocumentsType } from '../../../../models/_enum-collections';
import { ApiResponse } from '../../../../models/api-response.model';
import { DeclineReason } from '../../../../models/decline-reason.model';
import {
  DocumentDeclineReason,
  DocumentReviewModel
} from '../../../../models/document-review.model';
import {
  DocumentTypesString,
  DocumentTypes
} from '../../../../models/document-types.model';
import { IncentiveDetails } from '../../../../models/incentive-details.model';
import { IncentivePreviewInput } from '../../../../models/Incentive-preview-input.model';
import { InvoiceRejectReason } from '../../../../models/invoice-reject-reason';
import { NotesModel } from '../../../../models/notes.model';
import { PoeDocStatus } from '../../../../models/poe-doc-status.model';
import {
  UpdateAdvisorIncentivesPOEInformationRequest,
  UpdatePOEInformationRequestDocument
} from '../../../../models/poe-information-survey.model';
import { PoeInformation } from '../../../../models/poe-information.model';
import {
  PoeNominationDocuments,
  PoeNominationDocument
} from '../../../../models/poe-nomination-documents.model';
import { PoeStatus } from '../../../../models/poe-status.model';
import { PoeSurveyStatus } from '../../../../models/poe-survey-status.model';
import { UpdateCustomerAckDocument } from '../../../../models/update-customer-ack-document.model';
import { AppConstants } from '../../../common/app-constants';
import { CommonService } from '../../../common/common.service';
import { SettingsService } from '../../../common/settings.service';
import { CommonSharedModule } from '../../../common/shared.module';
import { DashboardService } from '../../../services/dashboard.service';
import { OsmosisEditService } from '../../../services/osmosis-edit.service';
import { IncentivePreviewComponent } from '../../incentive-preview/incentive-preview.component';

@Component({
  selector: 'app-incentive-poe-submission',
  templateUrl: './incentive-poe-submission.component.html',
  styleUrls: ['./incentive-poe-submission.component.scss'],
  standalone: true,
  imports: [CommonSharedModule, IncentivePreviewComponent]
})
export class IncentivePoeSubmissionComponent implements OnInit {
  @Input() incentiveDetails!: IncentiveDetails;
  @Output() refreshPartnerInput = new EventEmitter<void>();
  formPOESurvey!: FormGroup;
  uname!: string;
  apires!: ApiResponse;
  updatePoeInformationRequest!: UpdateAdvisorIncentivesPOEInformationRequest;
  incentiveId!: number;
  isReadonlyPOESurvey = true;
  btnNavPoeSurvey = false;
  PoeInformation!: PoeInformation[];
  declineReason!: DeclineReason[];
  partnerPOESurveyStatus!: PoeSurveyStatus[];
  PoeDocStatus!: PoeDocStatus[];
  msgsPoeSurvey!: any[];
  historyTableRow!: number;
  maxYearDate!: Date;

  notes!: NotesModel[];
  poeStatus!: PoeStatus[];
  poeNominationDocuments!: PoeNominationDocuments;
  poeNominationRequiredDocuments!: PoeNominationDocument[];
  poeDocumentRejectionReasons!: InvoiceRejectReason;
  poeInvoiceRejectionReasons!: InvoiceRejectReason;
  customerPOESurveyRejectionReasons: any;
  datePipe = new DatePipe('en-US');
  downloadSpin: boolean[] = [];
  incentivePreviewInput!: IncentivePreviewInput;
  canShowPreviewModel = false;
  loading!: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private osmEdit: OsmosisEditService,
    private settingsServices: SettingsService,
    private commonService: CommonService,
    private ds: DashboardService
  ) {}

  ngOnInit() {
    this.incentiveId = this.incentiveDetails.requestDetailId || -1;
    this.historyTableRow = AppConstants.historyTableRow;

    this.onFormGroup();
    this.getPoeStatus();
    this.getPoeDocumentStatus();
    this.getDetails();
  }

  getPoeDocumentStatus() {
    return this.osmEdit.getPoeDocStatusDropDown().subscribe(PTList => {
      const documentStatus = PTList.filter(
        sn =>
          sn.poeDocStatusName != 'Started' &&
          sn.poeDocStatusName != 'Not Started'
      );
      this.PoeDocStatus = documentStatus;
      this.getPoeDocumentsForEngagement();
    });
  }

  getPoeStatus() {
    this.osmEdit.getPoeStatusDropDown().subscribe(PTList => {
      this.poeStatus = PTList;
    });
  }

  checkPoeDocumentType(documentTypeId: number) {
    return DocumentTypesString[documentTypeId];
  }

  get DocumentTypesValue(): typeof DocumentTypes {
    return DocumentTypes;
  }

  getReasons(reasons: DocumentDeclineReason[]) {
    return reasons ? reasons.map(s => s.reason).join(', ') : '';
  }

  onFormGroup() {
    this.maxYearDate = new Date(
      new Date().setFullYear(new Date().getFullYear())
    );
    this.formPOESurvey = this.formBuilder.group({
      PoeStatus1: [''],
      poeDocumentSubmittedDate: [''],
      pOECompletionDate: [''],
      poeDOCstatusCn: [''],
      poeDocs: [],
      poeInvoiceDocId: '',
      poeDocumentRejectionReasonsCtrl: ['']
    });
  }

  editPoeSurveyCancel() {
    this.isReadonlyPOESurvey = true;
    this.msgsPoeSurvey = [];
    this.btnNavPoeSurvey = false;
    this.getDetails();
  }

  getConvertedStatusName(statusText: string) {
    return statusText == 'Submitted' ? 'In Review' : statusText;
  }

  getPoeDocumentStatusFormControl(
    documentType: DocumentTypes
  ): AbstractControl | null {
    switch (documentType) {
      case DocumentTypes.DealAssociationTemplate:
        return this.formPOESurvey.controls['poeDOCstatusCn'];
    }

    return null;
  }

  getPoeDocumentRejectReasonFormControl(
    documentType: DocumentTypes
  ): AbstractControl | null {
    switch (documentType) {
      case DocumentTypes.DealAssociationTemplate:
        return this.formPOESurvey.controls['poeDocumentRejectionReasonsCtrl'];
    }
    return null;
  }

  onPOEDocumentStatusChange(id: number, value: any): void {
    const currentArr = this.formPOESurvey.controls['poeDocs'].value;
    currentArr.forEach(doc => {
      if (doc.id === id) {
        doc.status = value.poeDocStatusName;
        doc.statusId = value.poeDocStatusId;
      }
    });
    this.formPOESurvey.controls['poeDocs'].setValue(currentArr);
  }

  getPoeDocumentsForEngagement() {
    this.osmEdit
      .getPOEDocumentsForEngagementDetail(this.incentiveId)
      .subscribe(response => {
        this.poeNominationDocuments = response;
        this.poeNominationRequiredDocuments =
          this.filterRequiredDocuments(response);
        this.poeNominationRequiredDocuments.forEach(document => {
          const statusText: string = this.getConvertedStatusName(
            document.status
          );
          const statusId = this.PoeDocStatus.find(
            s => s.poeDocStatusName == statusText
          )?.poeDocStatusId;
          const control = this.getPoeDocumentStatusFormControl(
            document.documentId
          );
          if (control != null) {
            control.setValue({
              poeDocStatusId: statusId,
              poeDocStatusName: statusText
            });
          }
          if (document['reasons']) {
            const rejectionReasonControl =
              this.getPoeDocumentRejectReasonFormControl(document.documentId);

            const reasons = document['reasons'].map(reason => {
              return {
                documentType: reason.documentType,
                reason: reason.reason,
                reasonID: reason.reasonId
              };
            });

            if (rejectionReasonControl) {
              rejectionReasonControl.setValue(reasons);
            }
          }
        });

        const documentIds = this.poeNominationRequiredDocuments.map(
          document => document.documentId
        );
        this.getRejectionReasonDropDown(documentIds).subscribe(result => {
          const rejectionReasons = [] as any;
          result.forEach(document => {
            if (document.length > 0) {
              const reason = {
                documentType: document[0].documentType,
                reason: document
              };
              rejectionReasons.push(reason);
            }
          });

          this.poeDocumentRejectionReasons = rejectionReasons.find(
            r => r.documentType == DocumentsType.DealAssociationTemplate
          );
        });
      });
  }

  hasValidRejectionReasons(documentType: DocumentTypes) {
    switch (documentType) {
      case DocumentTypes.DealAssociationTemplate:
        return this.poeDocumentRejectionReasons ? true : false;
      case DocumentTypes.POEInvoice:
        return this.poeInvoiceRejectionReasons ? true : false;
    }
    return false;
  }

  getRejectionReasonDropDown(documentIds: number[]) {
    const rejectionReasons: Observable<InvoiceRejectReason[]>[] = [];
    documentIds.forEach(id => {
      const documnetType: DocumentsType = id;
      rejectionReasons.push(
        this.osmEdit.getInvoiceRejectionReasonDropDown(documnetType)
      );
    });
    return forkJoin(rejectionReasons);
  }

  downloadPOE(downloadPOE: PoeNominationDocument) {
    this.downloadSpin[0] = true;
    const downloadAcknowledgementInputModel: UpdateCustomerAckDocument = {
      fileName: downloadPOE.fileName,
      engagementId: this.incentiveId
    };

    this.ds
      .getFileSasUrl(downloadAcknowledgementInputModel)
      .subscribe(downloadFileSasUrl => {
        window.location.href = downloadFileSasUrl;
      });
  }

  previewInvoice(document: PoeNominationDocument) {
    this.incentivePreviewInput = {
      engagementId: this.incentiveId,
      engagementIdList: [this.incentiveId],
      previewFileIndex: 0,
      dealAssociationDocument: document,
      incentiveName: this.incentiveDetails.deliveryName || '',
      customerOrgName: this.incentiveDetails.customerOrgName || '',
      partnerOrgName: this.incentiveDetails.partnerOrgName || '',
      partnerInputRequestorEmail:
        this.incentiveDetails.partnerInputRequestorEmail || '',
      committedDate: this.incentiveDetails.workshopCompletionDate || new Date(),
      day45ExpirationDate: this.incentiveDetails.day45ExpirationDate,
      incentiveExpirationDate: this.incentiveDetails.incentiveExpirationDate,
      documentTypeId: DocumentsType.DealAssociationTemplate,
      isPoePreview: false
    };
    this.canShowPreviewModel = true;
  }

  private filterRequiredDocuments(
    documents: PoeNominationDocuments
  ): PoeNominationDocument[] {
    return documents.poeDocuments;
  }

  getDetails() {
    const datePipe = new DatePipe('en-US');
    const poecompletionDate = datePipe.transform(
      this.incentiveDetails.poeCompletionDate,
      'MM/dd/yyyy'
    );
    const poeDocumentSubmittedDate = datePipe.transform(
      this.incentiveDetails.poeDocumentSubmittedDate,
      'MM/dd/yyyy'
    );

    this.formPOESurvey.patchValue({
      pOECompletionDate: poecompletionDate,
      poeDocumentSubmittedDate: poeDocumentSubmittedDate
    });

    this.formPOESurvey.controls['PoeStatus1'].setValue({
      poeStatusId: this.incentiveDetails.poeStatusId,
      poeStatusName: this.incentiveDetails.poeStatusName
    });

    this.formPOESurvey.controls['poeDOCstatusCn'].setValue({
      poeDocStatusId: this.incentiveDetails.poedoCstatusId,
      poeDocStatusName: this.incentiveDetails.poedoCstatus
    });
  }

  editPoeSurvey() {
    this.isReadonlyPOESurvey = false;
    this.btnNavPoeSurvey = true;
    this.msgsPoeSurvey = [];
  }

  onSubmitPOESurvey() {
    this.loading = true;
    let isValidForm = true;
    this.updatePoeInformationRequest =
      new UpdateAdvisorIncentivesPOEInformationRequest();
    this.updatePoeInformationRequest.requestDetailId = this.incentiveId;
    const datePipe = new DatePipe('en-US');

    this.updatePoeInformationRequest.poeStatusId =
      this.formPOESurvey.controls['PoeStatus1'].value.poeStatusId;
    this.updatePoeInformationRequest.poeStatusName =
      this.formPOESurvey.controls['PoeStatus1'].value.poeStatusName;

    const pOECompletionDate = datePipe.transform(
      this.formPOESurvey.controls['pOECompletionDate'].value,
      'MM/dd/yyyy'
    );
    this.updatePoeInformationRequest.poecompletionDate =
      pOECompletionDate || '';

    const pOEDocumentSubmittedDate = datePipe.transform(
      this.formPOESurvey.controls['poeDocumentSubmittedDate'].value,
      'MM/dd/yyyy'
    );
    this.updatePoeInformationRequest.pOEDocumentSubmittedDate =
      pOEDocumentSubmittedDate || '';

    this.uname = this.settingsServices.AliasName || '';
    this.updatePoeInformationRequest.lastUserAlias = this.uname;

    this.updatePoeInformationRequest.documents =
      this.poeNominationDocuments.poeDocuments.map(document => {
        const x = this.getPoeDocumentStatusFormControl(
          document.documentId
        )?.value;
        return new UpdatePOEInformationRequestDocument({
          documentStatusId:
            x.poeDocStatusId === undefined ? 6 : x.poeDocStatusId,
          documentId: document.oFactNominationPOEdocumentsId,
          documentTypeId: document.documentId,
          documentStatusName:
            x.poeDocStatusName === undefined ? 'Missing' : x.poeDocStatusName
        });
      });

    const rejectedDocuments = this.updatePoeInformationRequest.documents.filter(
      doc => doc.documentStatusName == 'Rejected'
    );
    this.updatePoeInformationRequest.documentsRejectionInfo =
      rejectedDocuments.map(document => {
        if (this.hasValidRejectionReasons(document.documentTypeId || -1)) {
          const selectedReasons = this.getPoeDocumentRejectReasonFormControl(
            document.documentTypeId || -1
          )?.value;

          if (selectedReasons.length > 0) {
            const documentReviewInfo: DocumentReviewModel = {
              requestDetailId: this.incentiveId,
              isApprove: false,
              documentType: document.documentTypeId || -1,
              reasons: [],
              oFactNominationPOEdocumentsId: document.documentId,
              filePath:
                this.poeNominationDocuments.poeDocuments.find(
                  doc =>
                    doc.oFactNominationPOEdocumentsId == document.documentId
                )?.filePath || ''
            };

            selectedReasons.forEach(element => {
              documentReviewInfo.reasons.push(element);
            });

            return documentReviewInfo;
          } else {
            isValidForm = false;
          }
        }
        return document;
      }) as any;

    if (isValidForm) {
      this.osmEdit
        .updateDealAssociationPOEInformation(this.updatePoeInformationRequest)
        .subscribe(
          messageResponse => {
            this.apires = messageResponse;
            if (this.apires.success === true) {
              this.refreshPartnerInput.emit();

              this.setValues();

              this.poeNominationRequiredDocuments.map(
                doc => (doc['reasons'] = null)
              );
              this.updatePoeInformationRequest.documentsRejectionInfo?.forEach(
                updatedDocument => {
                  if (
                    updatedDocument &&
                    updatedDocument.documentType !=
                      DocumentsType.CustomerPOESurvey
                  ) {
                    const index = this.poeNominationRequiredDocuments.findIndex(
                      doc => doc.documentId == updatedDocument.documentType
                    );
                    this.poeNominationRequiredDocuments[index]['reasons'] =
                      updatedDocument.reasons;
                  }
                }
              );

              const notRejectedDocs =
                this.updatePoeInformationRequest.documents?.filter(
                  doc => doc.documentStatusName != 'Rejected'
                );

              notRejectedDocs?.map(doc => {
                const rejectionReasonControl =
                  this.getPoeDocumentRejectReasonFormControl(
                    doc.documentTypeId || -1
                  );

                if (rejectionReasonControl) {
                  rejectionReasonControl.setValue(null);
                }
              });

              this.msgsPoeSurvey = [];
              this.isReadonlyPOESurvey = true;
              this.btnNavPoeSurvey = false;
              this.loading = false;
              this.msgsPoeSurvey.push({
                severity: 'success',
                detail: 'Poe Saved Successfully.'
              });
            }
            if (this.apires.success === false) {
              this.msgsPoeSurvey = [];
              this.loading = false;
              this.msgsPoeSurvey.push({
                severity: 'error',
                detail: this.apires.message
              });
            }
          },
          error => {
            this.msgsPoeSurvey = [];
            let errors: string[] = [];
            if (error.status === 400) {
              errors = this.commonService.getBadRequestErrors(error);
              for (const msg of errors) {
                this.loading = false;
                this.msgsPoeSurvey.push({ severity: 'warn', detail: msg });
              }
            } else {
              this.loading = false;
              this.msgsPoeSurvey.push({
                severity: 'warn',
                detail:
                  'Sorry an Error Occured while Adding PoeInformation Details'
              });
            }
          }
        );
    } else {
      this.msgsPoeSurvey = [];
      this.loading = false;
      this.msgsPoeSurvey.push({
        severity: 'warn',
        detail: 'Please choose reasons for rejected documents.'
      });
    }
  }

  setValues() {
    this.osmEdit
      .getIncentiveDataByRequestDetailsById(this.incentiveId)
      .subscribe(result => {
        this.incentiveDetails = result;
        this.getDetails();
      });
  }

  RefreshTab() {
    if (!this.btnNavPoeSurvey) {
      this.osmEdit
        .getIncentiveDataByRequestDetailsById(this.incentiveId)
        .subscribe(result => {
          this.incentiveDetails = result;
          this.getDetails();
        });
    }
  }

  reviewPoeDocument(event?: boolean) {
    if (event) {
      this.formPOESurvey.controls['poeDOCstatusCn'].setValue({
        poeDocStatusId: 5,
        poeDocStatusName: 'Completed'
      });
    } else {
      this.formPOESurvey.controls['poeDOCstatusCn'].setValue({
        poeDocStatusId: 4,
        poeDocStatusName: 'Rejected'
      });
    }
  }

  closePreview() {
    this.canShowPreviewModel = false;
    this.getPoeDocumentsForEngagement();
    this.refreshPartnerInput.emit();
    this.setValues();
  }
}
